// extracted by mini-css-extract-plugin
module.exports = {"heading":"MarketingPartnersList_heading__tmO_b","marketing-partners-list":"MarketingPartnersList_marketing-partners-list__t8gAz","link":"MarketingPartnersList_link__38EhH"};